jQuery(window).load(function() {
    jQuery('.match-height').matchHeight();
});

